<div class="error-information">
    <h1 class="error-code">{{ errorStatus }}</h1>
    <h3 class="error-description" *ngIf="errorMessage">{{ errorMessage | transloco }}</h3>
</div>
<p *ngIf="!trackingNumber">{{ 'ERROR.TEXT' | transloco }}</p>
<small *ngIf="trackingNumber"> {{ 'ERROR.TRACKING_NUMBER_HINT' | transloco }}: {{ trackingNumber }} </small>
